import * as Yup from 'yup';
import { ValidationErrorMessages } from './errors';

export const announcementValidator = Yup.object().shape({
  title: Yup.string().required(ValidationErrorMessages.REQUIRED),
  description: Yup.string().required(ValidationErrorMessages.REQUIRED),
  audience: Yup.number().required(ValidationErrorMessages.REQUIRED),
  senderAlias: Yup.string().when('$userRole', {
    is: 'Segreteria nazionale',
    then: (schema) => schema.required(ValidationErrorMessages.REQUIRED),
    otherwise: (schema) => schema.nullable().optional(),
  }),
});
